import React from 'react';

export default function TablePageMonthNav({
    monthNames,
    selectedYear,
    selectedMonth,
    viewModes,
    startYear,
    currentYear,
    onFirstMonth,
    onPrevMonth,
    onNextMonth,
    onLastMonth,
}) {
    const monthEnabled = Boolean(viewModes.month);
    return (
        <>
            <label>Maand:</label>
            <div className="project-month-nav">
                <button
                    type="button"
                    onClick={onFirstMonth}
                    disabled={!monthEnabled || selectedMonth === 1}
                    aria-label="Eerste maand"
                >
                    |&lt;
                </button>
                <button
                    type="button"
                    onClick={onPrevMonth}
                    disabled={
                        !monthEnabled || (selectedYear === startYear && selectedMonth === 1)
                    }
                >
                    &lt; Vorige maand
                </button>
                <span className="project-month-nav-current">
                    {monthNames[selectedMonth - 1]} {selectedYear}
                </span>
                <button
                    type="button"
                    onClick={onNextMonth}
                    disabled={
                        !monthEnabled ||
                        (selectedYear === currentYear && selectedMonth === 12)
                    }
                >
                    Volgende maand &gt;
                </button>
                <button
                    type="button"
                    onClick={onLastMonth}
                    disabled={!monthEnabled || selectedMonth === 12}
                    aria-label="Laatste maand"
                >
                    &gt;|
                </button>
            </div>
        </>
    );
}
